import { BaseModel } from "../base.model";

export class QuestionRangeGroupWeightingValue extends BaseModel {
  id: number;
  name: string;
  description: string;
  qRangeValue: number;
  weightedValue: number;
}
